import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-mobile-privacy-policy',
  templateUrl: './mobile-privacy-policy.component.html',
  styleUrls: ['./mobile-privacy-policy.component.css']
})
export class MobilePrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
